import React from 'react';
import classnames from 'classnames';
import { element, node, string } from 'prop-types';
import withLoading from '../wrappers/withLoading';
import Toolbar, { ToolbarRow, ToolbarSection } from '../toolbar';

const Card = ({
  title,
  subtitle,
  tools,
  actions,
  children,
  className,
  loadingComponent,
}) => (
  <div
    className={classnames(
      'mdc-card',
      className,
    )}
  >
    {loadingComponent}
    {title && (
      <Toolbar className="main-toolbar">
        <ToolbarRow>
          <ToolbarSection align={ToolbarSection.ALIGN_START} shrink>
            {title}
          </ToolbarSection>
          <ToolbarSection align={ToolbarSection.ALIGN_END} >
            {tools}
          </ToolbarSection>
        </ToolbarRow>
      </Toolbar>
    )}
    {subtitle}
    {children}
    {Boolean(actions.length) && (
      <section className="mdc-card__actions">
        {React.Children.map(actions, action => React.cloneElement(action, {
          className: classnames(
            action.className,
            'mdc-card__action',
          ),
        }))}
      </section>
    )}
  </div>
);

Card.propTypes = {
  actions: node,
  children: node,
  title: node,
  subtitle: node,
  className: string,
  loadingComponent: element.isRequired,
};

Card.defaultProps = {
  children: undefined,
  title: undefined,
  subtitle: undefined,
  actions: [],
  className: undefined,
};

export default withLoading()(Card);
